import { ContactController} from "../controller/ContactController";

class Contact{

    constructor(){
       
        /*
        Properties
        */

        this.id = null;
        this.nom = null;
        this.prenom = null;
        this.mail = null;
        this.adresse1 = null;
        this.adresse2 = null;
        this.codepostal = null;
        this.ville = null;
        this.telephone = null;
        this.commentaire = null;
        this.response = null;


    }

    /**
    * Accessors
    */

    getId(){
        return this.id;
    }

    setId(value){
        this.id = value;
    }

    getNom(){
        return this.nom;
    }

    setNom(value){
        this.nom = value;
    }

    getPrenom(){
        return this.prenom;
    }

    setPrenom(value){
        this.prenom = value;
    }

    getMail(){
        return this.mail;
    }

    setMail(value){
        this.mail = value;
    }

    getAdresse1(){
        return this.adresse1;
    }

    setAdresse1(value){
        this.adresse1 = value;
    }

    getAdresse2(){
        return this.adresse2;
    }

    setAdresse2(value){
        this.adresse2 = value;
    }

    getCodePostal(){
        return this.codepostal;
    }

    setCodePostal(value){
        this.codepostal = value;
    }

    getVille(){
        return this.ville;
    }

    setVille(value){
        this.ville = value;
    }

    getTelephone(){
        return this.telephone;
    }

    setTelephone(value){
        this.telephone = value;
    }

    getCommentaire(){
        return this.commentaire;
    }

    setCommentaire(value){
        this.commentaire = value;
    }

    getResponse(){
        return this.response;
    }

    setResponse(value){
        this.response = value;
    }

    /**
     * FUNCTIONS
     */
    async getContactByMail(mail){

        let contactController = new ContactController();
        let response= await contactController.getContactByMail(mail);

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.setId(response.dataArray.id);
            this.setNom(response.dataArray.nom);
            this.setPrenom(response.dataArray.prenom);
            this.setMail(response.dataArray.mail);
            this.setAdresse1(response.dataArray.adresse1);
            this.setAdresse2(response.dataArray.adresse2);
            this.setCodePostal(response.dataArray.codepostal);
            this.setVille(response.dataArray.ville);
            this.setTelephone(response.dataArray.telephone);
            this.setCommentaire(response.dataArray.commentaire);
            this.setResponse(response);
            
        }
        //Connection KO
        else{
            this.setId(null);
            this.setNom(null);
            this.setPrenom(null);
            this.setMail(null);
            this.setAdresse1(null);
            this.setAdresse2(null);
            this.setCodePostal(null);
            this.setVille(null);
            this.setTelephone(null);
            this.setCommentaire(null);
            this.setResponse(null);
        }

        let out = await {
            id: this.getId(),
            nom: this.getNom(),
            prenom: this.getPrenom(),
            mail: this.getMail(),
            adresse1: this.getAdresse1(),
            adresse2: this.getAdresse2(),
            codepostal: this.getCodePostal(),
            ville: this.getVille(),
            telephone: this.getTelephone(),
            commentaire: this.getCommentaire()
        }

        return await out;

    }


    async getContactById(id){
        let contactController = new ContactController();
        let response= await contactController.getContactByID(id);

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.setId(response.dataArray.id);
            this.setNom(response.dataArray.nom);
            this.setPrenom(response.dataArray.prenom);
            this.setMail(response.dataArray.mail);
            this.setAdresse1(response.dataArray.adresse1);
            this.setAdresse2(response.dataArray.adresse2);
            this.setCodePostal(response.dataArray.codepostal);
            this.setVille(response.dataArray.ville);
            this.setTelephone(response.dataArray.telephone);
            this.setCommentaire(response.dataArray.commentaire);
            this.setResponse(response);
            
        }
        //Connection KO
        else{
            this.setId(null);
            this.setNom(null);
            this.setPrenom(null);
            this.setMail(null);
            this.setAdresse1(null);
            this.setAdresse2(null);
            this.setCodePostal(null);
            this.setVille(null);
            this.setTelephone(null);
            this.setCommentaire(null);
            this.setResponse(null);
        }

        let out = await {
            id: this.getId(),
            nom: this.getNom(),
            prenom: this.getPrenom(),
            mail: this.getMail(),
            adresse1: this.getAdresse1(),
            adresse2: this.getAdresse2(),
            codepostal: this.getCodePostal(),
            ville: this.getVille(),
            telephone: this.getTelephone(),
            commentaire: this.getCommentaire()
        }

        return await out;
    }

    /*This function provide the full list of names & first names and id of all contacts
    return: [{name_firstname:'',id:''}]
    */ 
    async searchContacts(){
        let contactController = new ContactController();
        let response= await contactController.getContacts();

        //API call error
        if(response === undefined){
            return [];
        }
        //Connection OK
        if (response.response === '200'){
            
            let _ = require('underscore');
            var out_contacts = [];
            //debugger;
            //format data
            _.each(response.dataArray, function(contact){

                out_contacts.push({
                    id: contact.id,
                    name_firstname: contact.nom+" "+contact.prenom
                });


            });

            return out_contacts;
            
        }
        //API Call <> 200
        else{
            return [];
        }
        
    }




}
export default Contact;